enum PASS_STATUS {
  NOT_VISITED = 'not_visited',
  VISITED = 'visited',
  DONE = 'done',
}

export default PASS_STATUS;
